import { frLanguage } from './ressources/fr';

export const languageDictionary = {
  fr: frLanguage
};
